"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configureText = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/interopRequireWildcard"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _HtmlText = require("../../packages/HtmlText");
var _breakpoints = require("../breakpoints");
var _jsxRuntime = require("react/jsx-runtime");
const InlineDisclaimer = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../_nextgen/components/Disclaimer"));
  });
}, {
  resolveComponent: function (components) {
    return components.InlineDisclaimer;
  }
});
const Disclaimer = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../Disclaimer"));
  });
});
const LexusButton = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../LexusButton"));
  });
});
const Link = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../Link"));
  });
});
const Typography = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../Typography"));
  });
});
const Icon = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../_nextgen/components/Icon"));
  });
});
const RenderContent = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../RenderContent"));
  });
});
const {
  DynamicHeading,
  DynamicHeadingLevelProvider,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6
} = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../DynamicHeading"));
  });
});
const CollisionCenterLink = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../CollisionCenterLink"));
  });
});
const Spec = (0, _component.default)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../SpecsHighlight/SpecHighlight/Spec"));
  });
});
const Private = function (_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "data-cs-mask": "",
    "data-testid": "Private",
    children: children
  });
};
const configureText = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _HtmlText.configureHtmlText)({
    a: Link,
    LexusButton,
    Disclaimer,
    disclaimer: Disclaimer,
    InlineDisclaimer,
    MobileBreakpoint: _breakpoints.MobileBreakpoint,
    TabletBreakpoint: _breakpoints.TabletBreakpoint,
    DesktopBreakpoint: _breakpoints.DesktopBreakpoint,
    XLDesktopBreakpoint: _breakpoints.XLDesktopBreakpoint,
    Icon,
    Typography,
    RenderContent,
    Private,
    DynamicHeading,
    DynamicHeadingLevelProvider,
    H1,
    H2,
    H3,
    H4,
    H5,
    H6,
    CollisionCenterUrl: CollisionCenterLink,
    Spec,
    ...props
  });
};
exports.configureText = configureText;
const Text = configureText();
var _default = exports.default = Text;